import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { orderViewServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const orderViewInstance = axios.create({
  baseURL: orderViewServiceUrl,
  headers,
})

orderViewInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

orderViewInstance.interceptors.response.use(response => response, error => {
	return responseInterceptor(error)
})

export default orderViewInstance
